import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/exemption';

const namespace = 'ASSESSMENT';

export const EXEMPTIONS_FETCH_START = `${namespace}/EXEMPTIONS_FETCH_START`;
export const EXEMPTIONS_FETCH_SUCCESS = `${namespace}/EXEMPTIONS_FETCH_SUCCESS`;
export const EXEMPTIONS_FETCH_ERROR = `${namespace}/EXEMPTIONS_FETCH_ERROR`;

export const EXEMPTION_MAPPINGS_FETCH_START = `${namespace}/EXEMPTION_MAPPINGS_FETCH_START`;
export const EXEMPTION_MAPPINGS_FETCH_SUCCESS = `${namespace}/EXEMPTION_MAPPINGS_FETCH_SUCCESS`;
export const EXEMPTION_MAPPINGS_FETCH_ERROR = `${namespace}/EXEMPTION_MAPPINGS_FETCH_ERROR`;

export const EXEMPTION_APPLYTO_FETCH_START = `${namespace}/EXEMPTION_APPLYTO_FETCH_START`;
export const EXEMPTION_APPLYTO_FETCH_SUCCESS = `${namespace}/EXEMPTION_APPLYTO_FETCH_SUCCESS`;
export const EXEMPTION_APPLYTO_FETCH_ERROR = `${namespace}/EXEMPTION_APPLYTO_FETCH_ERROR`;

export const EXEMPTION_TYPES_FETCH_START = `${namespace}/EXEMPTION_TYPES_FETCH_START`;
export const EXEMPTION_TYPES_FETCH_SUCCESS = `${namespace}/EXEMPTION_TYPES_FETCH_SUCCESS`;
export const EXEMPTION_TYPES_FETCH_ERROR = `${namespace}/EXEMPTION_TYPES_FETCH_ERROR`;

export const CREATE_EXEMPTION_START = `${namespace}/CREATE_EXEMPTION_START`;
export const CREATE_EXEMPTION_SUCCESS = `${namespace}/CREATE_EXEMPTION_SUCCESS`;
export const CREATE_EXEMPTION_ERROR = `${namespace}/CREATE_EXEMPTION_ERROR`;

export const UPDATE_EXEMPTION_START = `${namespace}/UPDATE_EXEMPTION_START`;
export const UPDATE_EXEMPTION_SUCCESS = `${namespace}/UPDATE_EXEMPTION_SUCCESS`;
export const UPDATE_EXEMPTION_ERROR = `${namespace}/UPDATE_EXEMPTION_ERROR`;

export const DELETE_EXEMPTION_START = `${namespace}/DELETE_EXEMPTION_START`;
export const DELETE_EXEMPTION_SUCCESS = `${namespace}/DELETE_EXEMPTION_SUCCESS`;
export const DELETE_EXEMPTION_ERROR = `${namespace}/DELETE_EXEMPTION_ERROR`;

export const EXEMPTION_ORDERS_FETCH_START = `${namespace}/EXEMPTION_ORDERS_FETCH_START`;
export const EXEMPTION_ORDERS_FETCH_SUCCESS = `${namespace}/EXEMPTION_ORDERS_FETCH_SUCCESS`;
export const EXEMPTION_ORDERS_FETCH_ERROR = `${namespace}/EXEMPTION_ORDERS_FETCH_ERROR`;

export const fetchExemptions = makeApiActionCreatorV3(
  api.fetchExemptions,
  EXEMPTIONS_FETCH_START,
  EXEMPTIONS_FETCH_SUCCESS,
  EXEMPTIONS_FETCH_ERROR,
);

export const fetchExemptionMappings = makeApiActionCreatorV3(
  api.fetchExemptionMappings,
  EXEMPTION_MAPPINGS_FETCH_START,
  EXEMPTION_MAPPINGS_FETCH_SUCCESS,
  EXEMPTION_MAPPINGS_FETCH_ERROR,
);

export const fetchExemptionTypes = makeApiActionCreatorV3(
  api.fetchExemptionTypes,
  EXEMPTION_TYPES_FETCH_START,
  EXEMPTION_TYPES_FETCH_SUCCESS,
  EXEMPTION_TYPES_FETCH_ERROR,
);

export const fetchExemptionApplyTo = makeApiActionCreatorV3(
  api.fetchExemptionApplyTo,
  EXEMPTION_APPLYTO_FETCH_START,
  EXEMPTION_APPLYTO_FETCH_SUCCESS,
  EXEMPTION_APPLYTO_FETCH_ERROR,
);

export const createExemption = makeApiActionCreatorV3(
  api.createExemption,
  CREATE_EXEMPTION_START,
  CREATE_EXEMPTION_SUCCESS,
  CREATE_EXEMPTION_ERROR,
);

export const updateExemption = makeApiActionCreatorV3(
  api.updateExemption,
  UPDATE_EXEMPTION_START,
  UPDATE_EXEMPTION_SUCCESS,
  UPDATE_EXEMPTION_ERROR,
);

export const deleteExemption = makeApiActionCreatorV3(
  api.deleteExemption,
  DELETE_EXEMPTION_START,
  DELETE_EXEMPTION_SUCCESS,
  DELETE_EXEMPTION_ERROR,
);

export const fetchExemptionOrders = makeApiActionCreatorV3(
  api.fetchExemptionOrders,
  EXEMPTION_ORDERS_FETCH_START,
  EXEMPTION_ORDERS_FETCH_SUCCESS,
  EXEMPTION_ORDERS_FETCH_ERROR,
);
